<template>
  <div class="ActivityReport">
    <ReportPanel
      v-if="report"
      :title="title"
      :status="report.status">
      <div class="panel-body">
        <div
          class="row"
          v-for="item of items"
          :key="item.id">
          <ActivityReportItem
            :item="item"
            :read-only="readOnly" />
        </div>
      </div>
      <!-- panel-body -->
      <div
        class="panel-footer"
        v-if="!readOnly">
        <div class="footer-item">
          <IconButton
            icon="save"
            @click="save()"
            v-if="canSave"
            class="cta2 small">
            Save draft
          </IconButton>
        </div>
        <div class="footer-item">
          Total hours:
        </div>
        <div class="footer-item">
          <b>{{ total }}</b>
        </div>
        <div class="footer-item">
          <IconButton
            icon="send"
            v-if="canSubmit && confirm==false"
            @click="confirm=true"
            class="small">
            Submit report
          </IconButton>
          <div class="confirm-buttons">
            <IconButton
              v-if="confirm"
              icon="send"
              class="small confirm-submit"
              @click="submitReport()">
              Confirm {{ period }}
            </IconButton>
            <IconButton
              v-if="confirm"
              icon="close"
              class="small"
              @click="confirm=false">
              Cancel
            </IconButton>
          </div>
        </div>
      </div>
      <!-- panel-footer -->
    </ReportPanel><!-- panel -->
  </div>
  <!-- SalesReport -->
</template>

<script>
import gql from "graphql-tag";
import moment from "moment";
import ReportPanel from "@/components/ReportPanel";
import ActivityReportItem from "@/components/ActivityReportItem";

const categories = [
  'pt_hours',
  'pt_start',
  'pt_50_min',
  'pt_25_min',
  'service_intro',
  'service_campaign',
  'service_outside',
  'service_inside',
];


export default {
  components: { ReportPanel, ActivityReportItem },
  data: function () {
    return {
      report: null,
      confirm: false,
    };
  },
  props: {
    id: {
      type: String,
      required: true,
    },
  },
  filters: {
    period(val) {
      return moment(val).format("MMMM YYYY");
    },
  },

  computed: {
    title() {
      return `Activity Report ${this.period}`;
    },

    period() {
      return moment(this.report.periodStart).format("MMMM YYYY");
    },

    total() {
      return this.report.activityReportItemsList.reduce((acc, curr) => {
        return acc + parseInt(curr.quantity);
      }, 0);
    },

    readOnly() {
      return this.report.status === "SUBMITTED";
    },

    canSubmit() {
      return this.report.status === "DRAFT";
    },

    canSave() {
      return this.report.status === "DRAFT";
    },

    items() {
      const _items = this.report.activityReportItemsList;
      if (this.canSubmit) {
        return _items;
      }

      // imported activity reports does not
      // have all types of activities. So we add
      // some dummy placeholders with zero quantity
      // to improve the user experience
      const exists = _items.map(i => i.category);
      const missing = categories
        .filter(c => exists.indexOf(c) === -1)
        .map(m => ({ category: m, quantity: 0, id: null}));
      console.debug('items:', exists, missing)
      return [..._items, ...missing];
    }
  },

  apollo: {
    report() {
      return {
        fetchPolicy: "no-cache",
        query: gql`
          query ActivityReportQuery($id: UUID!) {
            activityReport(id: $id) {
              createdAt
              id
              periodEnd
              periodStart
              status
              activityReportItemsList {
                category
                createdAt
                id
                quantity
              }
            }
          }
        `,
        variables: { id: this.id },
        update: (data) => data.activityReport,
      };
    },
  },

  methods: {
    submitReport() {
      console.log("submitting activity report");
      this.$apollo
        .mutate({
          mutation: gql`
            mutation UpdateActivityReportMutation($id: UUID!) {
              updateActivityReport(
                input: { patch: { status: SUBMITTED }, id: $id }
              ) {
                clientMutationId
              }
            }
          `,
          variables: { id: this.report.id },
        })
        .then((response) => {
          this.$emit("activity-report-updated", response);
          this.save();
        })
        .catch((err) => {
          console.error("failed to submit sales report", err);
        });
    },

    save() {
      this.$router.push({ name: "reports", params: { show: "activity" } });
    },
  },
};
</script>

<style lang="scss" scoped>
.ActivityReport {
  padding: 1em;
  display: flex;

  table {
    border-collapse: collapse;

    thead {
      box-shadow: inset 0 -1px 0 0 var(--slate);
      opacity: 0.5;
    }

    th {
      opacity: 0.5;
      text-align: left;
      padding: 1em;
    }

    td {
      padding: 1em;
    }

    tr {
      border-bottom: 1px solid var(--pale-grey);
    }
  }

  .panel-body {
  }

  .panel-footer {
    padding: 1em;
    display: flex;
    align-items: baseline;
    justify-content: space-between;
  }

  .footer-item {
    font-size: 1.14em;
  }

  .confirm-buttons {
    display: flex;
    .confirm-submit {
      background-color: red;
      margin-right: 5px;
    }
  }

}
</style>
